import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants";

export const isWorkflowAttributeAllowedValue = objectOf({
  value: anyOf(string, number, boolean),
  description: string,
});

export const isWorkflowAttributeDefinitionResultObject = objectOf({
  id: string,
  type: enumOf("workflow_attribute"),
  name: string,
  description: string,
  data_type: enumOf(...sharedConstants.CONVERSATION_TOOL_DEFINITION.DATA_TYPES),
  allowed_values: arrayOf(isWorkflowAttributeAllowedValue),
  created_at: string,
  updated_at: string,
  created_by_email: string,
});

export const isConversationalToolDefinitionResultObject = isWorkflowAttributeDefinitionResultObject;

export const isConversationalToolDefinitionIdResult = objectOf({
  result: isConversationalToolDefinitionResultObject,
});
